import { Injectable } from '@angular/core';
import { where } from '@angular/fire/firestore';
import { CollectionPaths } from '@models/collections';
import { GlobalFormTemplate } from '@models/global-forms';
import { FirestoreRepo } from '@repos/firestore-repo.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class GlobalFormsRepo extends FirestoreRepo<GlobalFormTemplate, null> {
	constructor() {
		super(() => CollectionPaths.global_forms());
	}

	getMortgageFormsByLenderChargeType = (
		lenderId: string,
		chargeType: string,
	): Promise<GlobalFormTemplate[]> =>
		lenderId && chargeType
			? firstValueFrom(
					this.All(
						null,
						where('labels.lender', '==', lenderId),
						where(
							'labels.chargeTypes',
							'array-contains',
							chargeType?.toUpperCase(),
						),
					),
				)
			: Promise.resolve([]);
}
